<nb-card class="hours-overview">
  <nb-card-header>{{ 'invoice.new' | translate }}@if (projectName) {: {{ projectName }}}</nb-card-header>
  <nb-card-body>
    @if (projects) {
      @if (projects.length) {
        <div class="project">
          <label class="label">{{ 'invoice.project' | translate }}</label>
          <nb-select fullWidth size="small" [attr.aria-label]="'invoice.project' | translate" [placeholder]="'invoice.pick_project' | translate" [(selected)]="projectId">
            @for (project of projects; track project.id) {
              <nb-option [value]="project.id">{{ project.name }} · {{ project.client_name }}@if (project.status === ARCHIVED) { ({{ 'archived' | translate }})}</nb-option>
            }
          </nb-select>
        </div>
      } @else {
        <p class="warning">{{ 'invoice.no_projects' | translate }}</p>
      }
    }
    <form [formGroup]="form" class="period">
      <div>
        <label class="label">{{ 'hoursoverview.from' | translate }}</label>
        <input nbInput fieldSize="small" [attr.aria-label]="'hoursoverview.from' | translate" [nbDatepicker]="fromPicker" formControlName="from">
        <nb-datepicker #fromPicker format="DD-MM-YYYY"></nb-datepicker>
      </div>
      <div>
        <label class="label">{{ 'hoursoverview.to' | translate }}</label>
        <input nbInput fieldSize="small" [attr.aria-label]="'hoursoverview.to' | translate" [nbDatepicker]="toPicker" formControlName="to">
        <nb-datepicker #toPicker format="DD-MM-YYYY"></nb-datepicker>
      </div>
    </form>
    @if (!periodValid) {
      <p class="warning">{{ 'hoursoverview.invalidperiod' | translate }}</p>
    }
    <p class="muted">{{ 'invoice.new_hint' | translate }}</p>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton ghost size="small" (click)="close()">{{ 'cancel' | translate }}</button>
    <button nbButton status="primary" size="small" [disabled]="!valid || busy" (click)="create()">{{ 'invoice.create' | translate }}</button>
  </nb-card-footer>
</nb-card>
